import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { getUserInfo } from "@/api/api";

interface UserState {
  user: Record<string, unknown> | null;
  setUser: (user?: Record<string, unknown> | null) => Promise<void>;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      setUser: async (user) => {
        if (user !== undefined) {
          set({ user });
          return;
        }
        try {
          const { data: res }: any = await getUserInfo();
          set({ user: (res?.user ?? null) as Record<string, unknown> | null });
        } catch {
          set({ user: null });
        }
      },
      clearUser: () => set({ user: null }),
    }),
    {
      name: "user_info",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
